module.exports = {
    // Server API link: "https://tubefeel-api.noit.eu/"
    // Development API link: "http://localhost:8008"
    baseURL: "https://tubefeel-api.noit.eu/"
};